export const CleanNullishData = (data) => {
  console.log(data);
  return Object.keys(data).reduce((cleanData, key) => {
    if (data[key] !== null && data[key] !== undefined) {
      cleanData[key] = data[key];
    }
    return cleanData;
  }, {});
};
